import { message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import successIcon from '../../assets/images/success-icon.svg';
import React from 'react';


export const showCustomSuccessMessage = (msg = '') => {
    const key = Date.now();
    message.open({
        key,
        type: 'success',
        icon:<img src={successIcon} alt="success" style={{marginInlineEnd:"16px"}}  />,
        content: (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minWidth: "271px" }}>
                <span>{msg}</span>
                <CloseOutlined style={{ color: 'white', fontSize: "16px", marginInlineStart: "16px" }} onClick={() => message.destroy(key)} />
            </div>
        ),
       // duration:1000,
        className: "custom-success-toast"
    });
};
